module.exports = __webpack_public_path__ + "static/media/undo-alt-solid.2c391277.svg";